// Shared money model for the playable game flow — a VERBATIM port of the iOS
// GolfGamesScorecard utils/settlement.ts helpers (pairwise / teamSplit /
// payoutsToNets), so a site game's settle() produces the SAME zero-sum money as
// the app on identical inputs. Pure / node-safe (no JSX) so it stays testable.

// Zero-sum pairwise settlement from a per-player quantity (points, dots, vsQuota…).
export function pairwise(values, perUnit) {
  const n = values.length
  const total = values.reduce((s, v) => s + v, 0)
  return values.map((v) => (n * v - total) * perUnit)
}

// Split a team's net evenly across its members; produce a full per-player array.
export function teamSplit(n, t1, t2, team1Net) {
  const nets = Array(n).fill(0)
  t1.forEach((i) => { nets[i] = team1Net / t1.length })
  t2.forEach((i) => { nets[i] = -team1Net / t2.length })
  return nets
}

// Map an id→amount payout object (keyed pIDX) to an index-aligned array.
export function payoutsToNets(payouts, n) {
  return Array.from({ length: n }, (_, i) => payouts[`p${i}`] || 0)
}

// Build the per-player gross score array [h1..h18] from the playable flow's
// game.scores shape ({ [hole]: { [playerId]: gross } }). Missing/blank → null,
// matching what the engines expect (they skip null holes).
export function holeArray(scores, playerId) {
  const out = []
  for (let h = 1; h <= 18; h++) {
    const v = Number(scores?.[h]?.[playerId])
    out.push(Number.isFinite(v) && v > 0 ? v : null)
  }
  return out
}

// Attach a 0-based scores[] (+ handicap) to each registry player, so a raw
// engine (calcNines/calcChicago/…) can run on the flow's separate score store.
export function withScores(players, scores) {
  return (players || []).map((p) => ({
    id: p.id,
    name: p.name,
    handicap: Number(p.playingHandicap ?? p.courseHandicap ?? p.handicapIndex) || 0,
    scores: holeArray(scores, p.id),
  }))
}

// Round money to whole dollars for display (matches the app's Settle-Up rows).
export const money = (v) => Math.round((Number(v) || 0) * 100) / 100
